import Components from "../../components";
import settings from "./settings";

const Home = ({ data, dataSetter }) => {
  console.log("Home",settings)
  return (
    <div className="pb-20">
<Components.NavBar id="navbar1" label="NavBar" extendedSettings={settings} safeArea="data?.system?.safeArea" pixelRatio="data?.system?.pixelRatio" />
<Components.Chips id="chips1" label="Çipler" extendedSettings={settings} />
<Components.BannerSlider id="bannerslider1" label="Banner Slider 1" extendedSettings={settings} />
<Components.ProductSlider id="productslider1" label="Product Slider 1" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.ProductSlider id="productslider2" label="Product Slider 2" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.ProductSlider id="productslider3" label="Product Slider 3" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.ProductSlider id="productslider4" label="Product Slider 4" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.Marquee id="marquee1" label="Marquee 1" extendedSettings={settings} />
<Components.BannerSlider id="bannerslider2" label="Banner Slider 2" extendedSettings={settings} />
<Components.ProductGrid id="productgrid1" label="Product Grid" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.SingleProduct id="singleproduct1" label="Single Product" data={data} dataSetter={dataSetter} extendedSettings={settings} />
<Components.ProductSlider id="productslider5" label="Product Slider 5" extendedSettings={settings} data={data} dataSetter={dataSetter} />
<Components.SingleBanner id="singlebanner1" label="Single Banner" extendedSettings={settings} />
<Components.ProductSlider id="productslider6" label="Product Slider 6" extendedSettings={settings} data={data} dataSetter={dataSetter} />







    </div>
  );
};

export default Home;